export const setComponentData = (postComponent) => ({
  position: postComponent.position,
  id: postComponent.component_id || postComponent.componentId,
  componentName: postComponent.component_name || postComponent.componentName,
})
